var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"re-contact-patient-data"},[_c('div',[_c('h6',[_vm._v(_vm._s(_vm.patientName))]),_c('small',[_vm._v("ID "+_vm._s(_vm.lastData.id))])]),_c('contact-block',{ref:"contact"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }